import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pusher from 'pusher-js';
import "./TransactionHistory.css";
import axios from "axios";
import styled from "styled-components";
import CircularLoader from "../../Components/CircularLoader/CircularLoader";
import { useState } from "react";
import { useSocket } from "../../context/socketContext";
import environmentVariables from "../../config/environmentVariables";

const Heading = styled.div`
  font-family: SweraDemo;
  color: #e3e3e3;
  font-size: 24px;
  font-weight: 900;
  margin-bottom: 30px;
  margin: 50px 0 30px;
  @media (max-width: 768px) {
    margin: 20px 0 10px;
  }
`;

const TableStyle = styled(Table)`
  overflow-y: hidden !important;
`;
const HeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;
const HeadingTabsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 35%;
  // padding: 20px 0;
  border-radius: 10px;
  background-color: #64595933;
  @media (max-width: 768px) {
    width: auto;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
`;
const Tab = styled.div`
  cursor: pointer;
  color: ${(props) => (props.active ? "#fff" : "#9d9d9d")};
  @media (max-width: 768px) {
    font-size: 13px;
  }
`;
const TabWrapper = styled.div`
  padding: 20px 10px;

  @media (max-width: 768px) {
    padding: 5px 10px;
  }
`;
const NavWrapper = styled.div`
  display: flex;
`;

const UnOrderListWrapper = styled.ul`
  display: flex;
  justify-content: center;
  text-decoration: none;
  width: 100%;
  align-items: center;
  text-align: center;
  margin-top: 20px;
  padding-left: 0;
`;

const ListItemWrapper = styled.li`
  list-style-type: none;
  margin: 0 5px;
  color: white;
  @media (max-width: 768px) {
    margin: 0 2px;
  }
`;
const LoaderStyle = styled.div`
  min-width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
`;

const AnchorButton = styled.a`
  text-decoration: none;
  padding: 5px 10px;
  background-color: #267383;
  color: #fff;
  border: 1px solid #267383;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #fff;
    border: 1px solid #fff;
    color: black;
  }
  @media (max-width: 768px) {
    padding: 2px 6px;
    font-size: 10px;
  }
`;
const ActivePageNumber = styled.a`
  text-decoration: none;
  padding: 5px 10px;
  background-color: ${(props) => (props.active ? "#fff" : "#267383")};
  color: ${(props) => (props.active ? "#000" : "#fff")};
  border: 1px solid #267383;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #fff;
    border: 1px solid #fff;
    color: black;
  }
  @media (max-width: 768px) {
    padding: 2px 6px;
    font-size: 10px;
  }
`;

const SendBadge = styled.span`
  background: rgba(255, 59, 59, 0.15);
  color: #ff4d4f;
  padding: 6px 14px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  border: 1px solid #ff4d4f;
`;

const ReceiveBadge = styled.span`
  background: rgba(46, 204, 113, 0.15);
  color: #2ecc71;
  padding: 6px 14px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  border: 1px solid #2ecc71;
`;

export default function TransactionHistory({ allContractDetails }) {
  const [activeTab, setActiveTab] = useState(1);
  const socket = useSocket();
  // console.log(
  //   allContractDetails?.metalordNFTManagerContract?.address,
  //   "allContractDetails"
  // );

  const getMonthName = (num) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sepr",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[num];
  };
  const getConvertedTime = (unixTimestamp) => {
    const date = new Date(Number(unixTimestamp));
    // Get the various components of the date and time
    const year = date.getFullYear();
    const month = getMonthName(date.getMonth()); // Months are zero-indexed, so add 1
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds();

    // You can format these components as needed, for example, in a user-friendly string
    const formattedDate = `${month}-${day}-${year} , ${hours}:${minutes}`;

    // console.log(formattedDate);
    return formattedDate;
  };
  const columns = [
    { id: "Type", label: "Type", minWidth: 120 },
    { id: "TrxHash", label: "Hash", minWidth: 170 },
    { id: "TranAmount", label: "Amount", minWidth: 170 },
    { id: "TrxFees", label: "Transaction Fees", minWidth: 170 },
    // { id: "Method", label: "Method", minWidth: 100 },
    { id: "Time", label: "Time", minWidth: 120 },
    { id: "From", label: "From", minWidth: 170 },
    { id: "To", label: "To", minWidth: 170 },
  ];

  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loading, setLoading] = React.useState(true);
  const [totalPageLength, setPageLength] = React.useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(10);
  const params=new URLSearchParams(window.location.search);

  React.useEffect(()=>{
    const tokenName=params.get('token');
    if(tokenName=="MLD"||tokenName=="mld"||tokenName=="Mld"){
      setActiveTab(2);
      setLoading(true);
      setCurrentPage(1);
    }else if(tokenName=="LORD"||tokenName=="Lord"||tokenName=="lord"){
      setActiveTab(4);
      setLoading(true);
      setCurrentPage(1);
    }else if(tokenName=='USDT'||tokenName=="Usdt"||tokenName=="usdt"){
      setActiveTab(3);
      setLoading(true);
      setCurrentPage(1);
    }else if(tokenName=="MATIC"||tokenName=="Matic"||tokenName=="matic"){
      setActiveTab(1);
      setLoading(true);
      setCurrentPage(1);
    }
  },[])
  React.useEffect(()=>{
    if(allContractDetails?.address){
      socket.on("notifications",(data)=>{
        getTransactionHistory();
      })
    }
    return ()=>{
      socket.off("notifications")
    }
  },[allContractDetails,socket])
  const getTransactionHistory=()=>{
    let apiURL = ""; // Define the API URL based on the active tab
    if (activeTab === 1) {
      apiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/transaction/POL/${allContractDetails?.address}`;
    } else if (activeTab === 2) {
      apiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/transaction/MLD/${allContractDetails?.address}`;
    } else if (activeTab === 3) {
      apiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/transaction/USDT/${allContractDetails?.address}`;
    } else if (activeTab === 4) {
      apiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/transaction/LORD/${allContractDetails?.address}`;
    }
    axios
      .get(apiURL)
      .then((res) => {
        // console.log("resdataresdata", res.data);
        // console.log(setCheckToken)
        // setLoading(false);
        setRows([]);
        let resArr = [];
        res?.data?.data?.map((val) => {
          let obj = {};
          const userAddress = allContractDetails?.address?.toLowerCase();
          const from = val?.from?.toLowerCase();
          const to = val?.to?.toLowerCase();
        
          if (to === userAddress) {
            obj.Type = <ReceiveBadge>Received</ReceiveBadge>;
          } else if (from === userAddress) {
            obj.Type = <SendBadge>Sent</SendBadge>;
          } else {
            obj.Type = "-";
          }
          obj.TrxHash = `${val?.hash.slice(0, 8)}...${val?.hash.slice(-8)}`;
          obj.TrxFees = val?.trxFees ? `${Number(val.trxFees).toFixed(6)} POL` : `0 POL`;
          // obj.TranAmount = `${parseFloat(val?.value/100000000000000000)} Matic`
          if (activeTab === 1) {
            if (parseFloat(val.value) !== 0 || val.functionName === "") {
              obj.TranAmount = `${parseFloat(
                val?.amount
              )} POL`;
              // resArr = resArr.filter((row) => parseFloat(row.TranAmount) !== 0);
            } else {
              return null; // Skip this row
            }
            // obj.TranAmount = `${parseFloat(val?.value/1000000000000000000)} Matic`;
            // resArr = resArr.filter((row) => parseFloat(row.TranAmount) !==  0);
          } else if (activeTab === 2) {
            obj.TranAmount = `${parseFloat(
              val?.amount
            )} $MLD`;
          } else if (activeTab === 3) {
            obj.TranAmount = `${parseFloat(
              val?.amount
            )} USDT`;
          } else if (activeTab === 4) {
            obj.TranAmount = `${parseFloat(
              val?.amount
            )} $LORD`;
          }
          // obj.Method =
          //   val?.functionName == ""
          //     ? "transfer"
          //     : val?.functionName?.split("(")[0];
          obj.Time = getConvertedTime(val?.timestamp);
          obj.From = `${val?.from.slice(0, 8)}...${val?.from.slice(-8)}`;
          obj.To = `${val?.to.slice(0, 8)}...${val?.to.slice(-8)}`;
          obj.hash = val?.hash;
          resArr?.push(obj);
        });
        // console.log(resArr);
        setRows(resArr);
        setPageLength(resArr?.length);

        setLoading(false);
      })
      .catch((err) => console.log(err));
  }
  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
    setLoading(true);
    setCurrentPage(1);
  };
  // `https://api.polygonscan.com/api?module=account&action=txlist&address=${allContractDetails?.address}&startblock=0&endblock=99999999&page=${page + 1}&offset=${rowsPerPage}&sort=desc&apikey=PDFG7I8DKPHUYPFKBMR83ID7G1EDB2TUUB`
  React.useEffect(() => {
    // if (allContractDetails) {
    let apiURL = ""; // Define the API URL based on the active tab
    if (activeTab === 1) {
      apiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/transaction/POL/${allContractDetails?.address}`;
    } else if (activeTab === 2) {
      apiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/transaction/MLD/${allContractDetails?.address}`;
    } else if (activeTab === 3) {
      apiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/transaction/USDT/${allContractDetails?.address}`;
    } else if (activeTab === 4) {
      apiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/transaction/LORD/${allContractDetails?.address}`;
    }
    // console.log("API URL:", apiURL);
    axios
      .get(apiURL)
      .then((res) => {
        // console.log("resdataresdata", res.data);
        // console.log(setCheckToken)
        // setLoading(false);
        setRows([]);
        let resArr = [];
        res?.data?.data?.map((val) => {
          let obj = {};
            const userAddress = allContractDetails?.address?.toLowerCase();
            const from = val?.from?.toLowerCase();
            const to = val?.to?.toLowerCase();
          
            if (to === userAddress) {
              obj.Type = <ReceiveBadge>Received</ReceiveBadge>;
            } else if (from === userAddress) {
              obj.Type = <SendBadge>Sent</SendBadge>;
            } else {
              obj.Type = "-";
            }
          obj.TrxHash = `${val?.hash.slice(0, 8)}...${val?.hash.slice(-8)}`;
          // obj.TranAmount = `${parseFloat(val?.value/100000000000000000)} Matic`
          if (activeTab === 1) {
            if (parseFloat(val.value) !== 0 || val.functionName === "") {
              obj.TranAmount = `${parseFloat(
                val?.amount
              )} POL`;
              // resArr = resArr.filter((row) => parseFloat(row.TranAmount) !== 0);
            } else {
              return null; // Skip this row
            }
            // obj.TranAmount = `${parseFloat(val?.value/1000000000000000000)} Matic`;
            // resArr = resArr.filter((row) => parseFloat(row.TranAmount) !==  0);
          } else if (activeTab === 2) {
            obj.TranAmount = `${parseFloat(
              val?.amount
            )} $MLD`;
          } else if (activeTab === 3) {
            obj.TranAmount = `${parseFloat(
              val?.amount
            )} USDT`;
          } else if (activeTab === 4) {
            obj.TranAmount = `${parseFloat(
              val?.amount 
            )} $LORD`;
          }
          // obj.Method =
          //   val?.functionName == ""
          //     ? "transfer"
          //     : val?.functionName?.split("(")[0];
          obj.Time = getConvertedTime(val?.timestamp);
          obj.From = `${val?.from.slice(0, 8)}...${val?.from.slice(-8)}`;
          obj.To = `${val?.to.slice(0, 8)}...${val?.to.slice(-8)}`;
          obj.hash = val?.hash;
          obj.TrxFees = val?.trxFees ? `${Number(val.trxFees).toFixed(6)} POL` : `0 POL`;
          resArr?.push(obj);
        });
        // console.log(resArr);
        setRows(resArr);
        setPageLength(resArr?.length);

        setLoading(false);
      })
      .catch((err) => console.log(err));
    // }
  }, [allContractDetails, activeTab, rowsPerPage]);

  let IndexofLastrow = currentPage * postPerPage;
  let IndexforFirstrow = IndexofLastrow - postPerPage;
  let Currentrows = rows.slice(IndexforFirstrow, IndexofLastrow);

  let PageNumbers = [];
  let pageRange = 3; // Number of pages to show in between previous and next buttons
  let firstPage = Math.max(1, currentPage - pageRange);
  let lastPage = Math.min(
    Math.ceil(totalPageLength / postPerPage),
    currentPage + pageRange
  );

  if (lastPage < Math.ceil(totalPageLength / postPerPage)) {
    lastPage = Math.ceil(totalPageLength / postPerPage);
  }
  // let firstPage = 1;
  // let lastPage = Math.ceil(totalPageLength / postPerPage);
  let visiblePages = 3;
  for (let i = 1; i <= lastPage; i++) {
    PageNumbers.push(i);
  }
  let startPage = Math.max(currentPage - visiblePages, firstPage);
  let endPage = Math.min(currentPage + visiblePages, lastPage);

  if (firstPage <= visiblePages) {
    endPage = Math.min(firstPage + visiblePages * 2, lastPage);
  }

  if (endPage >= lastPage - visiblePages) {
    firstPage = Math.max(endPage - visiblePages * 2, firstPage);
  }
  const paginate = (PageNumbers) => {
    setCurrentPage(PageNumbers);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalPageLength / postPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getComponents=()=>{
     if(rows.length==0){
        return <>
        <TableRow>
        <TableCell
          colSpan={columns.length}
          sx={{
            textAlign: "center",
            color: "#c1c1c1de",
          }}
        >
          No Transaction available
        </TableCell>
      </TableRow></>
    }else{
      return <>{Currentrows.map((row,index) => {
        return (
          <TableRow
            onClick={() => {
              window.open(`https://polygonscan.com/tx/${row?.hash}`);
            }}
            sx={{
              borderBottom: "1px solid #161616",
              cursor: "pointer",
              color: "#fff",
              backgroundColor: index % 2 === 0 ? "rgba(255,255,255,0.03)" : "transparent",
            }}
            hover
            role="checkbox"
            tabIndex={-1}
            key={row.hash}
          >
            {columns.map((column) => {
              const value = row[column.id];
              return (
                <TableCell
                  sx={{
                    borderBottom: "1px solid #161616",
                    cursor: "pointer",
                    color: "#fff",
                    backgroundColor: index % 2 === 0 ? "rgba(255,255,255,0.06)" : "transparent",
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.1)"
                    }
                  }}
                  key={column.id}
                  align={column.align}
                >
                  {column.format && typeof value === "number"
                    ? column.format(value)
                    : value}
                </TableCell>
              );
            })}

            {/* <a
              target="_blank"
              href={`https://polygonscan.com/tx/${row.hash}`}
            >
              See More...
            </a> */}
          </TableRow>
        );
      })}</>
    }
   
  }
  // console.log(PageNumbers,"Page numbers")
  return (
    <Paper
      sx={{
        width: "90%",
        padding: "0 5%",
        overflow: "hidden",
        backgroundColor: "#fff0",
        margin: "0 auto",
      }}
    >
      <HeadingWrapper>
        <Heading>History </Heading>
        <HeadingTabsWrapper>
          <TabWrapper>
            {" "}
            <Tab active={activeTab === 1} onClick={() => handleTabClick(1)}>
              {" "}
              POL
            </Tab>
          </TabWrapper>
          <TabWrapper>
            <Tab active={activeTab === 2} onClick={() => handleTabClick(2)}>
              {" "}
              $MLD
            </Tab>
          </TabWrapper>
          <TabWrapper>
            {" "}
            <Tab active={activeTab === 3} onClick={() => handleTabClick(3)}>
              {" "}
              USDT
            </Tab>
          </TabWrapper>
          <TabWrapper>
            {" "}
            <Tab active={activeTab === 4} onClick={() => handleTabClick(4)}>
              {" "}
              $LORD
            </Tab>
          </TabWrapper>
        </HeadingTabsWrapper>
        {/* <div style={{color:"white"}}>
      {activeTab === 1 && <p>matic</p>}
      {activeTab === 2 && <p>Mld</p>}
      {activeTab === 3 && <p>Usdt</p>}
      {activeTab === 4 && <p>Lord</p>}
     </div> */}
      </HeadingWrapper>
      {loading?<>  <LoaderStyle>
              <CircularLoader></CircularLoader>
            </LoaderStyle></>:<TableContainer sx={{ maxHeight: 440 }}>
        <TableStyle stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  sx={{ color: "#000", fontWeight: "700", position: "static" }}
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          
            <TableBody>
             {getComponents()}
            </TableBody>
          
        </TableStyle>
      </TableContainer>}
      

      <NavWrapper>
        <UnOrderListWrapper>
          {currentPage > 1 && (
            <ListItemWrapper>
              <AnchorButton onClick={handlePreviousPage}>Previous</AnchorButton>
            </ListItemWrapper>
          )}
          {startPage > 1 && (
            <ListItemWrapper>
              <AnchorButton onClick={() => paginate(1)}>1</AnchorButton>
            </ListItemWrapper>
          )}
          {startPage > 2 && (
            <ListItemWrapper>
              <span style={{ color: "white" }}>...</span>
            </ListItemWrapper>
          )}
          {PageNumbers.slice(startPage - 1, endPage).map((number) => (
            <ListItemWrapper key={number}>
              <ActivePageNumber
                active={number === currentPage}
                onClick={() => paginate(number)}
              >
                {number}
              </ActivePageNumber>
            </ListItemWrapper>
          ))}
          {currentPage < lastPage ? (
            <ListItemWrapper>
              <AnchorButton onClick={handleNextPage}>Next</AnchorButton>
            </ListItemWrapper>
          ) : (
            currentPage < lastPage && (
              <ListItemWrapper>
                <AnchorButton onClick={handleNextPage}>Next</AnchorButton>
              </ListItemWrapper>
            )
          )}
        </UnOrderListWrapper>
      </NavWrapper>
    </Paper>
  );
}
